export default "/_next/static/images/4a38d29384e6be61f34639589d5da11a.svg";